import React from 'react';

/** Passive proportional chart; values and their accessible description belong to callers. */
export default function DonutChart({ segments, size = 68, label }) {
  const values = segments.filter((segment) => Number.isFinite(segment.value) && segment.value > 0);
  const total = values.reduce((sum, segment) => sum + segment.value, 0);
  let offset = 0;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      role="img"
      aria-label={label}
      className="shrink-0"
    >
      <circle cx="20" cy="20" r="16" fill="none" stroke="var(--bun-line)" strokeWidth="7" />
      {values.map((segment, index) => {
        const length = (segment.value / total) * 100;
        const start = offset;
        offset += length;
        return (
          <circle
            key={segment.id || index}
            cx="20"
            cy="20"
            r="16"
            pathLength="100"
            fill="none"
            stroke={segment.color}
            strokeWidth="7"
            strokeDasharray={`${length} ${100 - length}`}
            strokeDashoffset={-start}
            transform="rotate(-90 20 20)"
          />
        );
      })}
    </svg>
  );
}
